import React from "react";
import PropTypes from "prop-types";
import DismissButton from "../../Buttons/DismissButton/DismissButton";
import SuccessButton from "../../Buttons/SuccessButton/SuccessButton";

const NextStepModal = ({ children, onDismiss, onNext, showBack,isNexButtonFocused }) => (
  <div className="nextStepModal__outlet">
    <form
      className="nextStepModal__container"
      onSubmit={e => {
        e.preventDefault();
        onNext();
      }}
    >
      {children}
      <div className="nextStepModal__buttons">
        <DismissButton onClick={onDismiss}>
          {showBack ? "BACK" : "DISCARD"}
        </DismissButton>
        <SuccessButton type="submit" autoFocus={isNexButtonFocused} >NEXT</SuccessButton>
      </div>
    </form>
  </div>
);

NextStepModal.propTypes = {
  isNexButtonFocused: PropTypes.bool,
  /** Dismiss button function */
  onDismiss: PropTypes.func,
  /** Next button function */
  onNext: PropTypes.func
};
NextStepModal.defaultProps = {
  isNexButtonFocused: true
};

export default NextStepModal;
